import React from "react";
import LiveClassCardLogo from "../../assets/gif/liveclass.gif";
import { setBoardInfo } from "../../utils/authentication-access";
import BaseService from "../../store/services/base.service";
import { MenuItem, Menu } from "@material-ui/core";
import { BBB } from "../../utils";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import classes from "./class-card.module.css";
import { Mixpanel } from '../../utils/mixpanel';
import { withTranslation } from 'react-i18next';

class LiveClassCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optionopen: false,
      optionanchorEl: null
    };
  }

  gotoClass = () => {
    setBoardInfo(this.props.boardinfo);
    Mixpanel.track('Live Lesson Clicked');
    this.props.history.push("/class");
  };

  openOptionSettings = event => {
    event.stopPropagation();
    this.setState({ optionopen: !this.state.optionopen });
    this.setState({ optionanchorEl: event.currentTarget });
  };

  closeOptions = event => {
    event.stopPropagation();
    this.setState({ optionopen: false });
  };

  render() {
    const { t } = this.props;
    return (
      <div className="classcard-grid">
        <div className="classcard-img" onClick={this.gotoClass}>
          <img className="classlogo" src={LiveClassCardLogo} alt="Class" />
        </div>
        <div className={classes.CardFooter}>
          <span className={classes.CardTitle}>{this.props.boardinfo.name}</span>
          <MoreVertIcon
            style={{ color: "#677786" }}
            onClick={this.openOptionSettings}
          />
        </div>
        <Menu
          onClose={this.closeOptions}
          open={this.state.optionopen}
          anchorEl={this.state.optionanchorEl}
        >
          <MenuItem onClick={this.gotoClass}>{t("open")}</MenuItem>
        </Menu>
      </div>
    );
  }
}

export default withTranslation()(LiveClassCard);
